import { Box, Typography } from '@mui/material';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';

export default function MovingBanner() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        backgroundColor: 'transparent',
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        position: 'relative',
        whiteSpace: 'nowrap',
        // borderTop: "1px solid rgba(255, 215, 0, 0.2)",
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          animation: 'scrollLeft 8s linear infinite',
          gap: '30px',
        }}
      >
        {[...Array(10)].map((_, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <PaidOutlinedIcon sx={{ color: '#FFB300', fontSize: '18px' }} />
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: '800', // Extra bold
                color: '#FFB300',
                letterSpacing: '0.5px'
              }}
            >
              LIMITED TIME OFFER
            </Typography>
            <PaidOutlinedIcon sx={{ color: '#FFB300', fontSize: '18px' }} />
          </Box>
        ))}
      </Box>

      <style>
        {`
        @keyframes scrollLeft {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
      `}
      </style>
    </Box>
  );
}
